import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function PrivacyPolicy() {
  return <div className="w-full min-h-screen bg-slate-50" data-id="element-84">
      <div className="max-w-4xl mx-auto px-6 py-12" data-id="element-85">
        <Link to="/" className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-8 font-medium" data-id="element-86">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-87" />
          Back to Home
        </Link>
        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12" data-id="element-88">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8" data-id="element-89">
            Privacy Policy
          </h1>
          <div className="prose prose-slate max-w-none space-y-8" data-id="element-90">
            <section data-id="element-91">
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-92">
                Last updated:{' '}
                {new Date().toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
              })}
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-93">
                Pomelo Services Ltd ("us", "we", "our") is a limited liability
                company registered in England and Wales, number 13810984. Our
                registered office address is 128 City Road, London, United
                Kingdom, EC1V 2NX.
              </p>
              <p className="text-slate-700 leading-relaxed" data-id="element-94">
                This Privacy Policy describes how we collect, use, and protect
                your personal information when you use our Enhanced Payment
                Protection services and visit our website.
              </p>
            </section>
            <section data-id="element-95">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-96">
                1. Information We Collect
              </h2>
              <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-97">
                1.1 Information You Provide
              </h3>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-98">
                When you use our services, we may collect the following
                information:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-99">
                <li data-id="element-100">
                  Personal identification information (name, email address,
                  phone number)
                </li>
                <li data-id="element-101">
                  Payment card information (card number, expiry date, CVV)
                </li>
                <li data-id="element-102">Billing address and other contact details</li>
                <li data-id="element-103">Transaction history and payment details</li>
                <li data-id="element-104">Communication preferences</li>
              </ul>
              <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-105">
                1.2 Information We Collect Automatically
              </h3>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-106">
                When you access our services, we automatically collect:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-107">
                <li data-id="element-108">
                  Device information (IP address, browser type, operating
                  system)
                </li>
                <li data-id="element-109">Usage data (pages visited, time spent, features used)</li>
                <li data-id="element-110">Cookies and similar tracking technologies</li>
                <li data-id="element-111">Location data (with your consent)</li>
              </ul>
            </section>
            <section data-id="element-112">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-113">
                2. How We Use Your Information
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-114">
                We use your personal information for the following purposes:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2" data-id="element-115">
                <li data-id="element-116">To process and facilitate your payment transactions</li>
                <li data-id="element-117">
                  To provide and maintain our Enhanced Payment Protection
                  services
                </li>
                <li data-id="element-118">To verify your identity and prevent fraud</li>
                <li data-id="element-119">To comply with legal and regulatory obligations</li>
                <li data-id="element-120">
                  To communicate with you about your transactions and our
                  services
                </li>
                <li data-id="element-121">To improve our services and develop new features</li>
                <li data-id="element-122">
                  To send you marketing communications (with your consent)
                </li>
                <li data-id="element-123">
                  To respond to your inquiries and provide customer support
                </li>
                <li data-id="element-124">
                  To detect, prevent, and address technical issues and security
                  threats
                </li>
              </ul>
            </section>
            <section data-id="element-125">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-126">
                3. Legal Basis for Processing
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-127">
                We process your personal data under the following legal bases:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2" data-id="element-128">
                <li data-id="element-129">
                  <strong data-id="element-130">Contract Performance:</strong> Processing necessary to
                  fulfill our contractual obligations to you
                </li>
                <li data-id="element-131">
                  <strong data-id="element-132">Legal Obligation:</strong> Processing required to
                  comply with legal and regulatory requirements
                </li>
                <li data-id="element-133">
                  <strong data-id="element-134">Legitimate Interests:</strong> Processing necessary
                  for our legitimate business interests, such as fraud
                  prevention and service improvement
                </li>
                <li data-id="element-135">
                  <strong data-id="element-136">Consent:</strong> Processing based on your explicit
                  consent, which you may withdraw at any time
                </li>
              </ul>
            </section>
            <section data-id="element-137">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-138">
                4. How We Share Your Information
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-139">
                We may share your information with:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-140">
                <li data-id="element-141">
                  <strong data-id="element-142">Payment Service Providers:</strong> To process your
                  transactions securely
                </li>
                <li data-id="element-143">
                  <strong data-id="element-144">Merchants:</strong> Limited information necessary to
                  complete your purchase
                </li>
                <li data-id="element-145">
                  <strong data-id="element-146">Service Providers:</strong> Third parties who assist
                  us in operating our services
                </li>
                <li data-id="element-147">
                  <strong data-id="element-148">Regulatory Authorities:</strong> When required by law
                  or to comply with legal obligations
                </li>
                <li data-id="element-149">
                  <strong data-id="element-150">Law Enforcement:</strong> When necessary to protect
                  our rights or comply with legal processes
                </li>
                <li data-id="element-151">
                  <strong data-id="element-152">Business Transfers:</strong> In connection with a
                  merger, acquisition, or sale of assets
                </li>
              </ul>
              <p className="text-slate-700 leading-relaxed" data-id="element-153">
                We do not sell your personal information to third parties.
              </p>
            </section>
            <section data-id="element-154">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-155">
                5. Data Security
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-156">
                We implement robust security measures to protect your personal
                information:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2" data-id="element-157">
                <li data-id="element-158">PCI DSS Level 1 compliance for payment data</li>
                <li data-id="element-159">
                  Industry-standard encryption (TLS/SSL) for data transmission
                </li>
                <li data-id="element-160">Secure storage with encryption at rest</li>
                <li data-id="element-161">Regular security audits and vulnerability assessments</li>
                <li data-id="element-162">Access controls and authentication measures</li>
                <li data-id="element-163">Employee training on data protection and security</li>
                <li data-id="element-164">3D Secure authentication for eligible transactions</li>
                <li data-id="element-165">
                  Single-use virtual cards to protect your payment details
                </li>
              </ul>
            </section>
            <section data-id="element-166">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-167">
                6. Data Retention
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-168">
                We retain your personal information for as long as necessary to:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-169">
                <li data-id="element-170">Provide our services to you</li>
                <li data-id="element-171">Comply with legal and regulatory obligations</li>
                <li data-id="element-172">Resolve disputes and enforce our agreements</li>
                <li data-id="element-173">Maintain business records for legitimate purposes</li>
              </ul>
              <p className="text-slate-700 leading-relaxed" data-id="element-174">
                Transaction data is typically retained for a minimum of 7 years
                to comply with financial regulations. Once the retention period
                expires, we securely delete or anonymize your data.
              </p>
            </section>
            <section data-id="element-175">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-176">
                7. Your Rights
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-177">
                Under data protection laws, you have the following rights:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-178">
                <li data-id="element-179">
                  <strong data-id="element-180">Right of Access:</strong> Request a copy of the
                  personal data we hold about you
                </li>
                <li data-id="element-181">
                  <strong data-id="element-182">Right to Rectification:</strong> Request correction of
                  inaccurate or incomplete data
                </li>
                <li data-id="element-183">
                  <strong data-id="element-184">Right to Erasure:</strong> Request deletion of your
                  personal data (subject to legal obligations)
                </li>
                <li data-id="element-185">
                  <strong data-id="element-186">Right to Restriction:</strong> Request limitation on
                  how we process your data
                </li>
                <li data-id="element-187">
                  <strong data-id="element-188">Right to Data Portability:</strong> Receive your data
                  in a structured, machine-readable format
                </li>
                <li data-id="element-189">
                  <strong data-id="element-190">Right to Object:</strong> Object to processing based
                  on legitimate interests
                </li>
                <li data-id="element-191">
                  <strong data-id="element-192">Right to Withdraw Consent:</strong> Withdraw consent
                  for processing at any time
                </li>
                <li data-id="element-193">
                  <strong data-id="element-194">Right to Lodge a Complaint:</strong> Contact the
                  Information Commissioner's Office (ICO)
                </li>
              </ul>
              <p className="text-slate-700 leading-relaxed" data-id="element-195">
                To exercise any of these rights, please contact us at{' '}
                <a href="mailto:info@pomeloservices.uk" className="text-blue-600 hover:text-blue-700" data-id="element-196">
                  info@pomeloservices.uk
                </a>
              </p>
            </section>
            <section data-id="element-197">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-198">
                8. Cookies and Tracking Technologies
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-199">
                We use cookies and similar technologies to:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-200">
                <li data-id="element-201">Maintain your session and preferences</li>
                <li data-id="element-202">Analyze website usage and performance</li>
                <li data-id="element-203">Provide personalized content and advertising</li>
                <li data-id="element-204">Detect and prevent fraud</li>
              </ul>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-205">
                You can control cookies through your browser settings. However,
                disabling cookies may affect the functionality of our services.
              </p>
            </section>
            <section data-id="element-206">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-207">
                9. International Data Transfers
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-208">
                Your information may be transferred to and processed in
                countries outside the United Kingdom. When we transfer data
                internationally, we ensure appropriate safeguards are in place,
                including:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2" data-id="element-209">
                <li data-id="element-210">
                  Standard contractual clauses approved by the European
                  Commission
                </li>
                <li data-id="element-211">
                  Adequacy decisions recognizing equivalent data protection
                  standards
                </li>
                <li data-id="element-212">Other lawful transfer mechanisms under UK GDPR</li>
              </ul>
            </section>
            <section data-id="element-213">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-214">
                10. Children's Privacy
              </h2>
              <p className="text-slate-700 leading-relaxed" data-id="element-215">
                Our services are not intended for individuals under the age of
                18. We do not knowingly collect personal information from
                children. If you believe we have inadvertently collected
                information from a child, please contact us immediately.
              </p>
            </section>
            <section data-id="element-216">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-217">
                11. Changes to This Privacy Policy
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-218">
                We may update this Privacy Policy from time to time to reflect
                changes in our practices or legal requirements. We will notify
                you of any material changes by:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-219">
                <li data-id="element-220">Posting the updated policy on our website</li>
                <li data-id="element-221">
                  Updating the "Last updated" date at the top of this policy
                </li>
                <li data-id="element-222">
                  Sending you an email notification (for significant changes)
                </li>
              </ul>
              <p className="text-slate-700 leading-relaxed" data-id="element-223">
                We encourage you to review this Privacy Policy periodically to
                stay informed about how we protect your information.
              </p>
            </section>
            <section data-id="element-224">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-225">
                12. Contact Us
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-226">
                If you have any questions, concerns, or requests regarding this
                Privacy Policy or our data practices, please contact us:
              </p>
              <div className="bg-slate-50 rounded-lg p-6 space-y-2 text-slate-700" data-id="element-227">
                <p data-id="element-228">
                  <strong data-id="element-229">Pomelo Services Ltd</strong>
                </p>
                <p data-id="element-230">128 City Road</p>
                <p data-id="element-231">London, United Kingdom</p>
                <p data-id="element-232">EC1V 2NX</p>
                <p className="pt-2" data-id="element-233">
                  Email:{' '}
                  <a href="mailto:info@pomeloservices.uk" className="text-blue-600 hover:text-blue-700" data-id="element-234">
                    info@pomeloservices.uk
                  </a>
                </p>
                <p data-id="element-235">
                  Support:{' '}
                  <a href="mailto:enquiries@pomeloservices.uk" className="text-blue-600 hover:text-blue-700" data-id="element-236">
                    enquiries@pomeloservices.uk
                  </a>
                </p>
              </div>
            </section>
            <section data-id="element-237">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-238">
                13. Supervisory Authority
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-239">
                If you have concerns about how we handle your personal data, you
                have the right to lodge a complaint with the UK's supervisory
                authority:
              </p>
              <div className="bg-slate-50 rounded-lg p-6 space-y-2 text-slate-700" data-id="element-240">
                <p data-id="element-241">
                  <strong data-id="element-242">Information Commissioner's Office (ICO)</strong>
                </p>
                <p data-id="element-243">Wycliffe House, Water Lane</p>
                <p data-id="element-244">Wilmslow, Cheshire</p>
                <p data-id="element-245">SK9 5AF</p>
                <p className="pt-2" data-id="element-246">
                  Website:{' '}
                  <a href="https://ico.org.uk" className="text-blue-600 hover:text-blue-700" data-id="element-247">
                    https://ico.org.uk
                  </a>
                </p>
                <p data-id="element-248">Helpline: 0303 123 1113</p>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Footer data-id="element-249" />
    </div>;
}